import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const SwitchMeta: ComponentMeta = {
  componentName: "Switch",
  package: "@mijadesign/web",
  title: "开关",
  description: "用于切换两种状态的控制组件",
  category: ComponentCategory.FORM,
  icon: "SwapOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "checked",
      label: "是否选中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "checkedChildren",
      label: "选中时的内容",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "unCheckedChildren",
      label: "未选中时的内容",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "loading",
      label: "加载中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "默认", value: "default" },
        { label: "小", value: "small" },
      ],
      group: "样式",
    },
  ],
  defaultProps: {
    checked: false,
    size: "default",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Switch",
  },
  snippet: {
    componentName: "Switch",
    package: "@mijadesign/web",
    props: { checked: false },
  },
};
